import { useMemo } from 'react';
import type { Extension } from '@atlassian/jira-forge-ui-types/src/common/types/extension.tsx';
import { parseExtensionId } from '@atlassian/jira-forge-ui-utils-internal/src/utils/parse-extension-id/index.tsx';
import type { Match } from '@atlassian/react-resource-router';

export type Props<T> = {
	modules: T[] | null;
	match: Match;
};

export const useMatchedExtension = <T extends Extension>({
	modules,
	match,
}: Props<T>): T | undefined =>
	useMemo(
		() =>
			(modules || []).find((app: T) => {
				const parsedExtensionId = parseExtensionId(app.id);
				return (
					parsedExtensionId.appId === match.params.appId &&
					parsedExtensionId.envId === match.params.envId
				);
			}),
		[modules, match.params.appId, match.params.envId],
	);

export const useExtensionBasePath = (baseUrl: string, route?: string): string =>
	route !== undefined
		? baseUrl.replace(/\/?$/, '').slice(0, -route.length - 1)
		: baseUrl.replace(/\/?$/, '');
